// src/helpers.js
// Shared utility functions: hashing, localStorage, server save/load, AI calls.

export function hashPw(pw) {
  let h = 0;
  for (let i = 0; i < pw.length; i++) {
    h = ((h << 5) - h) + pw.charCodeAt(i);
    h |= 0;
  }
  return "h" + Math.abs(h).toString(36);
}

export function genTempPw() {
  const c = "ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789";
  return Array.from({length:10}, () => c[Math.floor(Math.random()*c.length)]).join("");
}

export function qColor(pct) {
  if (pct >= 80) return {bg:"#e8f5ee", bar:"#4a9e6e", text:"#2d6b47", label:"On Track"};
  if (pct >= 40) return {bg:"#fff8e6", bar:"#e8a838", text:"#8a5c10", label:"At Risk"};
  return {bg:"#fdecea", bar:"#c0614a", text:"#7a2415", label:"Behind"};
}

export function sGet(key) {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : null;
  } catch { return null; }
}

export function sSet(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
}

const API_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL + "/hubspot"
  : "/api/hubspot";

export async function aiCall(prompt) {
  const r = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action: "ai.complete", prompt }),
  });
  return r.json();
}

export async function serverSave(key, value) {
  try {
    await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "store.save", key, value }),
    });
  } catch (e) {
    console.warn("Server save failed:", e.message);
  }
}

export async function serverLoad(key) {
  try {
    const res = await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "store.load", key }),
    });
    const json = await res.json();
    return json.found ? json.data : null;
  } catch {
    return null;
  }
}
